import type { Maybe } from '@storefront/lib-global';
import { ColorName, Name } from './ProductName.styles';

type ProductNameProps = {
  name: string;
  colorName?: Maybe<string>;
};

export function ProductName({ name, colorName }: ProductNameProps) {
  // This avoids SEO issues caused by non-space-separated content and was found using Screaming Frog crawler
  // The space between product name and style name is intentional to ensure search engines can read the H1 tag as separate words
  const formattedName = `${name}${name && colorName ? ' ' : ''}`;

  return (
    <Name data-testid="productName">
      {formattedName}
      {colorName && <ColorName data-testid="productNameColor">{colorName}</ColorName>}
    </Name>
  );
}

export default ProductName;
